export enum LocaleType {
  ENGLISH = 'en',
  FRENCH = 'fr-CA'
}
